import { required_if } from 'vee-validate/dist/rules';
import { ValidatorUtils } from './utils';

export const requiredIfValidator = {
    ...required_if,
    message(field: string) {
        return `'${ValidatorUtils.prettifyName(field)}' is required`;
    },
};
